export default {
    language: 'Jazyk',
} as const;
